export enum EmbedMode {
  SIZED_CONTAINER = 'SIZED_CONTAINER'
}
